import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('club');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

// Players
export const playersAPI = {
  getAll: (params) => api.get('/players', { params }),
  getMine: () => api.get('/my-players'),
  getOne: (id) => api.get(`/players/${id}`),
  create: (data) => api.post('/players', data),
  update: (id, data) => api.put(`/players/${id}`, data),
  delete: (id) => api.delete(`/players/${id}`),
};

// Needs
export const needsAPI = {
  getAll: (params) => api.get('/needs', { params }),
  getMine: () => api.get('/my-needs'),
  getOne: (id) => api.get(`/needs/${id}`),
  create: (data) => api.post('/needs', data),
  update: (id, data) => api.put(`/needs/${id}`, data),
  delete: (id) => api.delete(`/needs/${id}`),
};

// Interests (in represented players)
export const interestsAPI = {
  getAll: () => api.get('/interests'),
  create: (data) => api.post('/interests', data),
  delete: (id) => api.delete(`/interests/${id}`),
};

// Admin Interests
export const adminInterestsAPI = {
  getAll: (params) => api.get('/admin/interests', { params }),
  update: (id, data) => api.put(`/admin/interests/${id}`, data),
  delete: (id) => api.delete(`/admin/interests/${id}`),
};

// Stats
export const statsAPI = {
  get: () => api.get('/stats'),
};

export default api;
